'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { TabNavigationContextProvider } from './TabNavigation.context.js';

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const TabNavigationProvider = (props)=>{
    const { children } = props, others = _object_without_properties_loose(props, [
        "children"
    ]);
    return /*#__PURE__*/ jsx(TabNavigationContextProvider, {
        value: others,
        children: children
    });
};

export { TabNavigationProvider };
//# sourceMappingURL=TabNavigationProvider.js.map
